export default __webpack_public_path__ + "static/media/announcement_icon.66391a30.svg";